var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735028375597,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14663,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M514.592 71.104c-144.096 0-260.992 118.464-260.992 264.544a264.832 264.832 0 0 0 109.696 214.912c-135.36 59.36-230.144 195.872-230.144 354.944h0.896c1.536 21.376 18.656 38.368 40.128 38.368s38.56-17.056 40.128-38.368h0.64c0-0.928-0.096-1.792-0.096-2.72v-0.16l-0.064-0.192c0.064-159.968 120-291.04 273.024-304.928 8.96 0.928 17.6 2.72 26.848 2.72 144.096 0 260.992-118.464 260.992-264.544s-116.928-264.544-261.024-264.544z m0 447.36c-99.776 0-180.704-81.984-180.704-183.168s80.864-183.168 180.704-183.168c99.712 0 180.64 81.984 180.64 183.168s-80.864 183.168-180.64 183.168z m381.44 384.16c0-0.352-0.192-0.64-0.192-0.992a388.224 388.224 0 0 0-111.36-269.12 38.88 38.88 0 0 0-28-11.968c-21.568 0-39.136 17.76-39.136 39.68 0 11.136 4.576 21.12 11.84 28.32l-0.096 0.064a308.64 308.64 0 0 1 85.312 213.856c0 1.056-0.16 1.984-0.16 3.04h0.992c1.504 21.376 18.688 38.368 40.128 38.368 21.472 0 38.56-17.056 40.128-38.368h0.608c0-0.8-0.096-1.504-0.096-2.272-0.064-0.16 0.064-0.352 0.064-0.544z",
    "p-id": 14664,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.7aea613ccbae835244556d2ce1328627.svg";
export { ForwardRef as ReactComponent };